module.exports = __webpack_public_path__ + "img/08.bf08cab2.jpg";